export default {
   "bpowner": "",
   "bpcompany": "",
   "bpcontactno": "",
   "bpaddr1": "",
   "bpaddr2": "",
   "bpaddr3": "",
   "bpcity": "",
   "bpstate": "",
   "bppostcode": "",
}
